import { resetStateToDefault } from '@/utils'
import { IRequestSolicitacaoHorasExtras } from './SolicitacaoHorasExtras.modelo'
import moment from 'moment'

interface State {
  justificativa: string | null
  dataDeInicio: string | null
  dataDeFim: string | null
  horaDeInicio: string | null
  horaDeFim: string | null
}

const estadosPadrao = () => ({
  justificativa: null,
  dataDeInicio: null,
  dataDeFim: null,
  horaDeInicio: null,
  horaDeFim: null
})

const mutations = {
  resetState (state: State) {
    resetStateToDefault(state, estadosPadrao())
  },
  salvarDadosConfirmacaoPedido (state: State, { inicioDaHoraExtra, fimDaHoraExtra, justificativa }: IRequestSolicitacaoHorasExtras) {
    const horaInicio = moment(inicioDaHoraExtra).format('HH:mm')
    const horaFim = moment(fimDaHoraExtra).format('HH:mm')
    const dataInicio = moment(inicioDaHoraExtra).format('DD/MM/YYYY')
    const dataFim = moment(fimDaHoraExtra).format('DD/MM/YYYY')

    state.justificativa = justificativa
    state.horaDeInicio = horaInicio
    state.horaDeFim = horaFim
    state.dataDeInicio = dataInicio
    state.dataDeFim = dataInicio === dataFim ? null : dataFim
  }
}

export default {
  state: estadosPadrao(),
  mutations,
  namespaced: true
}
